import { type PayloadAction, createSlice } from '@reduxjs/toolkit'

export interface IAuthState {
  isAuth: boolean
}

const initialState: IAuthState = {
  isAuth: false,
}

const authSlice = createSlice({
  name: 'auth',
  initialState,
  reducers: {
    setAuth: (state, action: PayloadAction<boolean>) => {
      state.isAuth = action.payload
    },
  },
})

export const authActions = authSlice.actions

export const authReducer = authSlice.reducer
